import {
  MissionDetailsSelection,
  RunDetailsSelection,
} from '@mobile-mapping/providers';
import { JSX } from 'solid-js';
import { useProjectDataPanel } from '@trimble/project-data-panel-ui';
import MissionSelectionTreeContainer, {
  MissionTreeNodeData,
} from '../MissionSelectionTreeContainer';
import { ProjectDataTreeContainerProps } from './shared-panel.types';

export interface SharedMissionTreeContainerProps
  extends ProjectDataTreeContainerProps<MissionTreeNodeData> {
  onRunDetailsSelect?(run: RunDetailsSelection): void;
  onMissionDetailsSelect?(mission: MissionDetailsSelection): void;
}

export const SharedMissionTreeContainer = (
  props: SharedMissionTreeContainerProps
): JSX.Element => {
  const { filterText, sortBy, sortDirection, filterMode } =
    useProjectDataPanel();

  return (
    <MissionSelectionTreeContainer
      nodes={props.nodes}
      childrenLoadStatus={props.childrenLoadStatus}
      defaultExpandIds={props.defaultExpandIds}
      filterKey={props.filterKey}
      filterText={props.nodes === undefined ? filterText() : undefined}
      highlightText={props.highlightText}
      sortBy={sortBy()}
      sortDirection={sortDirection()}
      filterMode={filterMode()}
      onRunDetailsSelect={props.onRunDetailsSelect}
      onMissionDetailsSelect={props.onMissionDetailsSelect}
    />
  );
};
